export default function Category({ category }) {
  return <span>{category.name}</span>;
}
